import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconUpload = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d='M15 16H1a1 1 0 01-1-1v-5h2v4h12v-4h2v5a1 1 0 01-1 1z' />
            <path d='M8 12a1 1 0 01-1-1V2a1 1 0 012 0v9a1 1 0 01-1 1z' />
            <path d='M12 6a1 1 0 01-.71-.29L8 2.41l-3.29 3.3a1 1 0 01-1.42-1.42l4-4a1 1 0 011.42 0l4 4a1 1 0 010 1.42A1 1 0 0112 6z' />
        </svg>
    );
};

IconUpload.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
    color: PropTypes.oneOf(['primaryBlue', 'secondaryBlue', 'darkGrey', 'white']),
};
IconUpload.defaultProps = {
    size: 'sm',
    color: 'darkGrey',
    focusable: false,
};
export default IconUpload;
